module.exports = __webpack_public_path__ + "i18n/es_9fa3b7a66e7a9a11282f2835f9e86da5.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/es.json
// module id = +lAx
// module chunks = 153